import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { useAuth0 } from "@auth0/auth0-react";

const Login = () => {

     const { loginWithRedirect } = useAuth0();

    return (
        <Container
            fluid
            className="vh-100 d-flex justify-content-center align-items-center" >
            <Row className="w-100 justify-content-center" style={{ marginTop: '-100px' }}>
                <Col xs={10} sm={8} md={6} lg={4}>
                    <Card>
                        <Card.Body>
                            <Card.Title className="text-center mb-4">Login</Card.Title>
                            <Button variant="primary" type="submit" className="w-100" onClick={() => loginWithRedirect()}>
                                Login
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
